/**
 * Vacuum tubes. The uncommon crafting material, and the reason anything in the hub still lights up.
 */

import type { JunkItem } from '@/sim/items/itemContract';

export const VACUUM_TUBES = {
  id: 'vacuumTubes',
  kind: 'junk',
  label: 'Vacuum tubes',
  description: 'Coldbrook stock, warm to the touch after forty years. Nobody has asked why.',
  rarity: 'uncommon',
  weightKg: 0.18,
  stackLimit: 30,
  equip: null,
  scrapValue: 26,
} as const satisfies JunkItem;
